"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetSignerParams = exports.SetSignerSignature = exports.ActionSigner = exports.creationFlowToJSON = exports.creationFlowFromJSON = exports.CreationFlow = exports.protobufPackage = void 0;
/* eslint-disable */
const timestamp_1 = require("../google/protobuf/timestamp");
const minimal_1 = require("protobufjs/minimal");
exports.protobufPackage = "thesixnetwork.sixnft.nftoracle";
var CreationFlow;
(function (CreationFlow) {
    CreationFlow[CreationFlow["ORACLE"] = 0] = "ORACLE";
    CreationFlow[CreationFlow["INTERNAL_OWNER"] = 1] = "INTERNAL_OWNER";
    CreationFlow[CreationFlow["UNRECOGNIZED"] = -1] = "UNRECOGNIZED";
})(CreationFlow = exports.CreationFlow || (exports.CreationFlow = {}));
function creationFlowFromJSON(object) {
    switch (object) {
        case 0:
        case "ORACLE":
            return CreationFlow.ORACLE;
        case 1:
        case "INTERNAL_OWNER":
            return CreationFlow.INTERNAL_OWNER;
        case -1:
        case "UNRECOGNIZED":
        default:
            return CreationFlow.UNRECOGNIZED;
    }
}
exports.creationFlowFromJSON = creationFlowFromJSON;
function creationFlowToJSON(object) {
    switch (object) {
        case CreationFlow.ORACLE:
            return "ORACLE";
        case CreationFlow.INTERNAL_OWNER:
            return "INTERNAL_OWNER";
        default:
            return "UNKNOWN";
    }
}
exports.creationFlowToJSON = creationFlowToJSON;
const baseActionSigner = {
    actor_address: "",
    owner_address: "",
    creator: "",
    creation_flow: 0,
};
exports.ActionSigner = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.actor_address !== "") {
            writer.uint32(10).string(message.actor_address);
        }
        if (message.owner_address !== "") {
            writer.uint32(18).string(message.owner_address);
        }
        if (message.created_at !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.created_at), writer.uint32(26).fork()).ldelim();
        }
        if (message.expired_at !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.expired_at), writer.uint32(34).fork()).ldelim();
        }
        if (message.creator !== "") {
            writer.uint32(42).string(message.creator);
        }
        if (message.creation_flow !== 0) {
            writer.uint32(48).int32(message.creation_flow);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseActionSigner);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.actor_address = reader.string();
                    break;
                case 2:
                    message.owner_address = reader.string();
                    break;
                case 3:
                    message.created_at = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 4:
                    message.expired_at = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                case 5:
                    message.creator = reader.string();
                    break;
                case 6:
                    message.creation_flow = reader.int32();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseActionSigner);
        if (object.actor_address !== undefined && object.actor_address !== null) {
            message.actor_address = String(object.actor_address);
        }
        else {
            message.actor_address = "";
        }
        if (object.owner_address !== undefined && object.owner_address !== null) {
            message.owner_address = String(object.owner_address);
        }
        else {
            message.owner_address = "";
        }
        if (object.created_at !== undefined && object.created_at !== null) {
            message.created_at = fromJsonTimestamp(object.created_at);
        }
        else {
            message.created_at = undefined;
        }
        if (object.expired_at !== undefined && object.expired_at !== null) {
            message.expired_at = fromJsonTimestamp(object.expired_at);
        }
        else {
            message.expired_at = undefined;
        }
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = String(object.creator);
        }
        else {
            message.creator = "";
        }
        if (object.creation_flow !== undefined && object.creation_flow !== null) {
            message.creation_flow = creationFlowFromJSON(object.creation_flow);
        }
        else {
            message.creation_flow = 0;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.actor_address !== undefined &&
            (obj.actor_address = message.actor_address);
        message.owner_address !== undefined &&
            (obj.owner_address = message.owner_address);
        message.created_at !== undefined &&
            (obj.created_at =
                message.created_at !== undefined
                    ? message.created_at.toISOString()
                    : null);
        message.expired_at !== undefined &&
            (obj.expired_at =
                message.expired_at !== undefined
                    ? message.expired_at.toISOString()
                    : null);
        message.creator !== undefined && (obj.creator = message.creator);
        message.creation_flow !== undefined &&
            (obj.creation_flow = creationFlowToJSON(message.creation_flow));
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseActionSigner);
        if (object.actor_address !== undefined && object.actor_address !== null) {
            message.actor_address = object.actor_address;
        }
        else {
            message.actor_address = "";
        }
        if (object.owner_address !== undefined && object.owner_address !== null) {
            message.owner_address = object.owner_address;
        }
        else {
            message.owner_address = "";
        }
        if (object.created_at !== undefined && object.created_at !== null) {
            message.created_at = object.created_at;
        }
        else {
            message.created_at = undefined;
        }
        if (object.expired_at !== undefined && object.expired_at !== null) {
            message.expired_at = object.expired_at;
        }
        else {
            message.expired_at = undefined;
        }
        if (object.creator !== undefined && object.creator !== null) {
            message.creator = object.creator;
        }
        else {
            message.creator = "";
        }
        if (object.creation_flow !== undefined && object.creation_flow !== null) {
            message.creation_flow = object.creation_flow;
        }
        else {
            message.creation_flow = 0;
        }
        return message;
    },
};
const baseSetSignerSignature = { signature: "", message: "" };
exports.SetSignerSignature = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.signature !== "") {
            writer.uint32(10).string(message.signature);
        }
        if (message.message !== "") {
            writer.uint32(18).string(message.message);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSetSignerSignature);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.signature = reader.string();
                    break;
                case 2:
                    message.message = reader.string();
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSetSignerSignature);
        if (object.signature !== undefined && object.signature !== null) {
            message.signature = String(object.signature);
        }
        else {
            message.signature = "";
        }
        if (object.message !== undefined && object.message !== null) {
            message.message = String(object.message);
        }
        else {
            message.message = "";
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.signature !== undefined && (obj.signature = message.signature);
        message.message !== undefined && (obj.message = message.message);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSetSignerSignature);
        if (object.signature !== undefined && object.signature !== null) {
            message.signature = object.signature;
        }
        else {
            message.signature = "";
        }
        if (object.message !== undefined && object.message !== null) {
            message.message = object.message;
        }
        else {
            message.message = "";
        }
        return message;
    },
};
const baseSetSignerParams = { owner_address: "", actor_address: "" };
exports.SetSignerParams = {
    encode(message, writer = minimal_1.Writer.create()) {
        if (message.owner_address !== "") {
            writer.uint32(10).string(message.owner_address);
        }
        if (message.actor_address !== "") {
            writer.uint32(18).string(message.actor_address);
        }
        if (message.expired_at !== undefined) {
            timestamp_1.Timestamp.encode(toTimestamp(message.expired_at), writer.uint32(26).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof Uint8Array ? new minimal_1.Reader(input) : input;
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = Object.assign({}, baseSetSignerParams);
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    message.owner_address = reader.string();
                    break;
                case 2:
                    message.actor_address = reader.string();
                    break;
                case 3:
                    message.expired_at = fromTimestamp(timestamp_1.Timestamp.decode(reader, reader.uint32()));
                    break;
                default:
                    reader.skipType(tag & 7);
                    break;
            }
        }
        return message;
    },
    fromJSON(object) {
        const message = Object.assign({}, baseSetSignerParams);
        if (object.owner_address !== undefined && object.owner_address !== null) {
            message.owner_address = String(object.owner_address);
        }
        else {
            message.owner_address = "";
        }
        if (object.actor_address !== undefined && object.actor_address !== null) {
            message.actor_address = String(object.actor_address);
        }
        else {
            message.actor_address = "";
        }
        if (object.expired_at !== undefined && object.expired_at !== null) {
            message.expired_at = fromJsonTimestamp(object.expired_at);
        }
        else {
            message.expired_at = undefined;
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        message.owner_address !== undefined &&
            (obj.owner_address = message.owner_address);
        message.actor_address !== undefined &&
            (obj.actor_address = message.actor_address);
        message.expired_at !== undefined &&
            (obj.expired_at =
                message.expired_at !== undefined
                    ? message.expired_at.toISOString()
                    : null);
        return obj;
    },
    fromPartial(object) {
        const message = Object.assign({}, baseSetSignerParams);
        if (object.owner_address !== undefined && object.owner_address !== null) {
            message.owner_address = object.owner_address;
        }
        else {
            message.owner_address = "";
        }
        if (object.actor_address !== undefined && object.actor_address !== null) {
            message.actor_address = object.actor_address;
        }
        else {
            message.actor_address = "";
        }
        if (object.expired_at !== undefined && object.expired_at !== null) {
            message.expired_at = object.expired_at;
        }
        else {
            message.expired_at = undefined;
        }
        return message;
    },
};
function toTimestamp(date) {
    const seconds = date.getTime() / 1000;
    const nanos = (date.getTime() % 1000) * 1000000;
    return { seconds, nanos };
}
function fromTimestamp(t) {
    let millis = t.seconds * 1000;
    millis += t.nanos / 1000000;
    return new Date(millis);
}
function fromJsonTimestamp(o) {
    if (o instanceof Date) {
        return o;
    }
    else if (typeof o === "string") {
        return new Date(o);
    }
    else {
        return fromTimestamp(timestamp_1.Timestamp.fromJSON(o));
    }
}
//# sourceMappingURL=action_signer.js.map